'use client';

import { useEffect } from 'react';
import {
  usePathname,
  useRouter as useRouterI18n,
} from 'modules/i18n/navigation';
import { useSiteConfig } from '../shop/siteConfig/hooks';

export { usePathname } from 'modules/i18n/navigation';

/**
 * extend i18n/navigation useRouter to handle pageLoader state
 */
export const useRouter = () => {
  const router = useRouterI18n();
  const pathname = usePathname();
  const { togglePageLoading } = useSiteConfig();

  useEffect(() => {
    togglePageLoading?.(false);
  }, [pathname]);

  return {
    ...router,
    push(...args: Parameters<typeof router.push>) {
      pathname !== args[0] && togglePageLoading?.(true);

      return router.push(...args);
    },

    replace(...args: Parameters<typeof router.replace>) {
      pathname !== args[0] && togglePageLoading?.(true);

      return router.replace(...args);
    },
  };
};
